import React from "react";
import { Typography, Button, Space, Tag } from "antd";
import { RedoOutlined } from "@ant-design/icons";
import StatChips from "../StatChips/StatChips";
import env from "../../config/env";

const { Title, Text } = Typography;

const AppHeader = ({
  countdown,
  isLoading,
  isBackgroundRefreshing,
  onRefresh,
  stats,
}) => (
  <div className="app-header">
    <div className="app-header__content">
      <div className="app-header__left">
        <div className="app-header__brand">
          <img
            src={env.logoUrl}
            alt="Red Grape Technologies"
            className="app-header__logo"
          />
          {/* <div>
            <Title level={3} className="app-header__title">
              Gitdash
            </Title>
            <Text type="secondary">
              GitLab issues tracker for Red Grape
            </Text>
          </div> */}
        </div>
      </div>

      <div className="app-header__center">
        <StatChips stats={stats} />
      </div>

      <div className="app-header__right">
        <Space size="middle" wrap>
          <Tag color="blue" className="refresh-tag">
            Next refresh: {countdown <= 1 ? "..." : `${countdown}s`}
          </Tag>
          {isBackgroundRefreshing && (
            <Tag color="processing">Syncing in background</Tag>
          )}
          <Button
            type="primary"
            icon={<RedoOutlined />}
            onClick={onRefresh}
            disabled={isLoading}
          >
            Refresh
          </Button>
        </Space>
      </div>
    </div>
  </div>
);

export default AppHeader;
